module.exports = __webpack_public_path__ + "images/0ee0f0a3230160ad37fccb1fa79ce690.svg";